module.exports = __webpack_public_path__ + "img/primary-vector.95587acb.svg";